import { useContext } from 'react';

import SkillData from '../../../types/skillData';
import { AuthContext } from '../../../utils/AuthProvider';
import useSectionsWithProgress from '../../../utils/hooks/useSectionsWithProgress';
import IconButtonLink from '../../atoms/anchor/IconButtonLink';
import ProgressBar from '../../atoms/progress-bar/ProgressBar';
import SectionList from '../../molecules/skill-list/SectionList';
import { useIsModerator } from '../../../utils/hooks';

interface YourProgressSidebarContentProps {
  skill: SkillData;
  showSectionManagerButton?: boolean;
}

export function SkillProgressSidebarContent({
  skill,
  showSectionManagerButton = false,
}: YourProgressSidebarContentProps) {
  const { user } = useContext(AuthContext)!;
  const [sections, sectionsWithoutProgress] = useSectionsWithProgress(skill, user);
  const isModerator = useIsModerator(user);
  const isAuthor = skill.authorUuid === user?.uid;
  const completeSections = sections?.filter(section => section.complete).length;

  return !user && sectionsWithoutProgress ? (
    <div className="flex flex-col h-full">
      {
        <div className="mb-8">
          <SectionList sections={sectionsWithoutProgress} skill={skill} />
        </div>
      }
      <ProgressBar
        className="mt-auto border-t-2 border-b-2 pb-4 pt-3"
        completeSections={0}
        totalSections={sectionsWithoutProgress.length}
      />
    </div>
  ) : (
    <div className="flex flex-col h-full">
      {sections && (
        <div className="mb-8">
          <SectionList className="mt-6" sections={sections} skill={skill} />
        </div>
      )}
      <div className="flex flex-col grow px-8 pb-6">
        {(isModerator || isAuthor) && sections && showSectionManagerButton && (
          <IconButtonLink
            to={`/skills/${skill.slug}/sections/edit`}
            icon={`${sections.length > 0 ? 'edit-outline' : 'add'}`}
            label={`${sections.length > 0 ? 'Manage sections' : 'Add sections'}`}
          />
        )}
        {sections !== undefined && sections.length > 0 && completeSections !== undefined && (
          <ProgressBar
            className="mt-auto border-t-2 border-b-2 pb-4 pt-3"
            completeSections={completeSections}
            totalSections={sections.length}
          />
        )}
      </div>
    </div>
  );
}
